import React from 'react';
import '@configuratorware/configurator-frontendgui/Framework/Components/LoadingOverlay/Styles.scss';
import CustomProgress from '../CustomProgress/CustomProgress';

interface LoadingOverlayProps {
  show: boolean;
}
const LoadingOverlay = (props: LoadingOverlayProps) => (
  <div className={'loadingoverlay ' + (props.show ? 'show' : 'hide')} onClick={(e) => e.stopPropagation()}>
    <CustomProgress loading={props.show} />
  </div>
);

export default LoadingOverlay;
